import Overflow from "rc-overflow";

import "./BTOverflowDeprecated.less";

/**
 * Give this component a list of JSX.Element's and it will automatically convert them to a dropdown menu on small devices
 * @example
 * <BTOverflow
 *  renderRest={(omittedItems) => { }}
 *  data={[
 *    <>item 1</>,
 *    <>item 2</>,
 *    <>item 3</>,
 *  ]}
 *  suffix={<div>Always show this</div>}
 * />
 */
export interface IBTOverflowProps<ItemType> {
    className?: string;
    style?: React.CSSProperties;
    data: ItemType[];
    itemKey?: React.Key | ((item: ItemType) => React.Key);
    renderItem?: (item: ItemType) => React.ReactNode;

    /** @default responsive */
    maxCount?: number | "responsive" | "invalidate";
    renderRest: (omittedItems: ItemType[]) => React.ReactNode;
    suffix?: React.ReactNode;

    itemWidth?: number;
    "data-testid"?: string;
}

/**
 * The BTOverflowDeprecated component is a wrapper around the Overflow component from the rc-overflow library. It provides a convenient API for rendering a list of items that can automatically overflow into a dropdown menu on smaller screens. The component accepts various props for customizing its behavior and appearance, including className, style, data, itemKey, renderItem, maxCount, renderRest, suffix, itemWidth, and data-testid for testing purposes.
 * @param props The props for the BTOverflowDeprecated component, which include className, style, data, itemKey, renderItem, maxCount, renderRest, suffix, itemWidth, and data-testid.
 * @returns A JSX element representing the BTOverflowDeprecated component with the specified props.
 * @deprecated This component is deprecated and should not be used in new code. Please use the new BTOverflow component instead, which provides improved functionality and better integration with Fluent UI.
 */
export const BTOverflowDeprecated = function <ItemType = undefined>({
    className,
    style,
    data,
    itemKey,
    renderItem,
    maxCount = "responsive",
    renderRest,
    suffix,
    itemWidth,
    "data-testid": dataTestId,
}: IBTOverflowProps<ItemType>) {
    return (
        <Overflow
            className={className}
            style={style}
            data={data}
            itemKey={itemKey}
            renderItem={renderItem}
            maxCount={maxCount}
            renderRest={renderRest}
            suffix={suffix}
            itemWidth={itemWidth}
            data-testid={dataTestId}
        />
    );
};
